import {
  ICertMasterPracticeProduct,
  ICertMasterPracticeEntitlementRedemptionRequest,
  IEntitlement,
  IEntitlementRedemptionRequest,
  IAccessKeyVendor,
  ICertMasterPlatformAccessKeyRedemption,
  ICertMasterPlatformAccessKeyValid,
} from '@comptia-sso/core';

// Config.
import { env } from 'config';

// Services.
import { getRequest, postRequest } from './api';

export const getCertMasterProducts = (
  accessKey: string,
  cmpId?: string,
): Promise<ICertMasterPracticeProduct[]> =>
  getRequest<ICertMasterPracticeProduct[]>(
    [
      `${env.ENTITLEMENTS_API_HOST}/api/vendors/cmp/${accessKey}`,
      cmpId && `?cmpId=${cmpId}`,
    ]
      .filter(Boolean)
      .join(''),
    env.ENTITLEMENTS_API_KEY,
  );

export const redeemAccessKey = (
  values: IEntitlementRedemptionRequest,
): Promise<IEntitlement> =>
  postRequest<IEntitlement, IEntitlementRedemptionRequest>(
    `${env.ENTITLEMENTS_API_HOST}/api/redemptions/redeem`,
    values,
    env.ENTITLEMENTS_API_KEY,
  );

export const redeemCertMasterPracticeAccessKey = (
  values: ICertMasterPracticeEntitlementRedemptionRequest,
): Promise<boolean> =>
  postRequest<boolean, ICertMasterPracticeEntitlementRedemptionRequest>(
    `${env.ENTITLEMENTS_API_HOST}/api/redemptions/cmp/redeem`,
    values,
    env.ENTITLEMENTS_API_KEY,
  );

export const getAccesskeyVendor = (
  accessKey: string,
): Promise<IAccessKeyVendor> =>
  getRequest(
    `${env.ENTITLEMENTS_API_HOST}/api/vendors/getvendor/${accessKey}`,
    env.ENTITLEMENTS_API_KEY,
  );

export const redeemCertMasterPlatformAccessKey = (
  values: IEntitlementRedemptionRequest,
): Promise<ICertMasterPlatformAccessKeyRedemption> =>
  postRequest<
    ICertMasterPlatformAccessKeyRedemption,
    IEntitlementRedemptionRequest
  >(
    `${env.ENTITLEMENTS_API_HOST}/api/redemptions/certmaster-platform`,
    values,
    env.ENTITLEMENTS_API_KEY,
  );

export const getCertMasterPlatformAccessKeyValid = (
  accessKey: string,
): Promise<ICertMasterPlatformAccessKeyValid> =>
  getRequest<ICertMasterPlatformAccessKeyValid>(
    `${env.ENTITLEMENTS_API_HOST}/api/redemptions/certmaster-platform/access-key/${accessKey}/is-valid`,
    env.ENTITLEMENTS_API_KEY,
  );

export const getCertMasterPlatformAccessKeyCECheck = (
  accessKey: string,
  userId: string,
): Promise<void> =>
  getRequest<void>(
    `${env.ENTITLEMENTS_API_HOST}/api/redemptions/certmaster-platform/access-key/${accessKey}/ce-check/${userId}`,
    env.ENTITLEMENTS_API_KEY,
  );
